<template>
  <v-card>
    <v-card-title class="headline">{{ title }}</v-card-title>

    <v-card-text>
      <p class="mb-2">{{ message }}</p>

      <v-textarea
        v-model="reason"
        label="Raison du rejet"
        auto-grow
        outlined
        rows="3"
        required
      ></v-textarea>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text color="orange" @click="$emit('cancel')">Annuler</v-btn>
      <v-btn
        color="primary"
        :disabled="!reason"
        @click="submit"
      >
        Envoyer
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    item: Object,
    title: String,
    message: String
  },
  data() {
    return {
      reason: ''
    }
  },
  methods: {
    submit() {
      this.$emit('noValidateItem', {
        reason: this.reason,
        item: this.item
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ActorValidationReject.vue